import { useQuery } from '@tanstack/react-query';
import { getLatestDraft } from '../../../api/cmail.api';

export const useLatestDraft = (msgId: string) => {
  return useQuery({
    queryKey: ['latest-draft', msgId],
    queryFn: async () => {
      try {
        const response = await getLatestDraft({ params: { msgId } });
        return response.data || null; // Always return something
      } catch (err: any) {
        if (err?.response?.status === 404) {
          return null;
        }
        throw err;
      }
    },
    enabled: Boolean(msgId),
    retry: false,
    staleTime: 30000,
  });
};
